import React, { Component } from 'react'
import { connect } from 'react-redux'
import T from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Button from '@material-ui/core/Button'
import RecoveryPasswordForm from 'components/auth/RecoveryPassword/RecoveryPassword'
import { recoveryPassword, resetTokenExist } from 'reducers/auth/reducer'
import withPromise from 'helpers/withPromise'
import { APP_URL_LOGIN } from 'constants/index'
import Locale from 'components/common/Locale/Locale'
import * as ROUTE from 'constants/appRouting'
import messages from './translate'

class RecoveryPassword extends Component {
  UNSAFE_componentWillMount() {
    const {
      resetTokenExist,
      match: {
        params: { token },
      },
    } = this.props

    resetTokenExist({ reset_token: token })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { exist, history } = this.props

    if (exist !== nextProps.exist) {
      history.replace(APP_URL_LOGIN)
    }
  }

  recoveryPassword = data => {
    const {
      history,
      recoveryPassword,
      match: {
        params: { token },
      },
    } = this.props

    return withPromise(recoveryPassword, {
      ...data,
      reset_token: token,
    }).then(res => {
      if (res && res.error) return Promise.resolve(res.error.errorString)
      history.push(ROUTE.LOGIN)
    })
  }

  onBackToLogin = () => {
    const { history } = this.props
    history.replace(ROUTE.LOGIN)
  }

  render() {
    return (
      <div className="recovery-password-form">
        <div className="form-headline">
          <h2>
            <FormattedMessage {...messages.reset_password} />
          </h2>
          <Locale />
        </div>
        <hr />
        <RecoveryPasswordForm onSubmit={this.recoveryPassword} />
        <Button
          fullWidth
          href={null}
          color="default"
          size="large"
          variant="contained"
          type="button"
          onClick={this.onBackToLogin}>
          <FormattedMessage {...messages.back_to_signin} />
        </Button>
      </div>
    )
  }
}

RecoveryPassword.propTypes = {
  exist: T.bool.isRequired,
  history: T.object.isRequired,
  match: T.shape({
    params: T.shape({
      token: T.string,
    }),
  }).isRequired,
  resetTokenExist: T.func,
  recoveryPassword: T.func,
}

RecoveryPassword.defaultProps = {
  resetTokenExist: () => {},
  recoveryPassword: () => {},
}

const enhance = connect(
  state => ({
    exist: state.getIn(['auth', 'exist']),
  }),
  {
    recoveryPassword,
    resetTokenExist,
  },
)

export default enhance(RecoveryPassword)
